"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenTypes = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const tokenTypes = exports.tokenTypes = {
  itemIconSize: _propTypes.default.number.isRequired,
  itemIconColor: _propTypes.default.string.isRequired,
  listGutter: _propTypes.default.number.isRequired,
  iconMarginTop: _propTypes.default.number.isRequired
};
const selectItemIconTokens = _ref => {
  let {
    itemIconSize,
    itemIconColor
  } = _ref;
  return {
    size: itemIconSize,
    color: itemIconColor
  };
};
const selectSideItemContainerStyles = _ref2 => {
  let {
    listGutter,
    iconMarginTop
  } = _ref2;
  return {
    marginTop: iconMarginTop,
    marginRight: listGutter
  };
};

// Align bullets with the top line of text the same way icons are aligned
const selectBulletPositioningStyles = _ref3 => {
  let {
    itemIconSize
  } = _ref3;
  return {
    width: itemIconSize,
    height: itemIconSize
  };
};
const selectBulletContainerStyles = _ref4 => {
  let {
    itemBulletContainerWidth,
    itemBulletContainerHeight,
    itemBulletContainerAlign
  } = _ref4;
  return {
    width: itemBulletContainerWidth,
    height: itemBulletContainerHeight,
    alignItems: itemBulletContainerAlign
  };
};
const getIconColorVariants = iconVariants => iconVariants?.filter(variant => variant[0] === 'color').map(variant => variant[1]);

/**
 * Subcomponent used within ListItem and similar components for rendering bullets or icons
 * that sit alongside a ListIconContent in a { flexDirection: row } container.
 *
 * It's the responsibility of themes to make sure that the supplied tokens align the
 * icon or bullet nicely against the first line of text in a ListIconContent.
 */
const ListItemMark = /*#__PURE__*/_react.default.forwardRef((_ref5, ref) => {
  let {
    icon,
    iconColor,
    iconSize,
    tokens = {}
  } = _ref5;
  const themeTokens = typeof tokens === 'function' ? tokens() : tokens;
  const sideItemContainerStyles = selectSideItemContainerStyles(themeTokens);
  const bulletContainerStyles = selectBulletContainerStyles(themeTokens);

  // TODO: Remove it when iconColor custom colors are deprecated.
  const iconVariants = (0, _utils.useVariants)('Icon');
  const iconColorVariants = getIconColorVariants(iconVariants);
  if (icon) {
    const iconTokens = selectItemIconTokens(themeTokens);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: [sideItemContainerStyles, bulletContainerStyles],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: icon,
        tokens: {
          size: iconSize ?? iconTokens.size,
          ...((iconColor && !iconColorVariants?.includes(iconColor) || !iconColor) && {
            color: iconColor && !iconColorVariants?.includes(iconColor) ? iconColor : iconTokens.color
          })
        },
        variant: {
          ...(iconColorVariants?.includes(iconColor) && {
            color: iconColor
          })
        }
      })
    });
  }
  const bulletColor = themeTokens.itemBulletColor;
  const {
    bulletIcon
  } = themeTokens;
  const itemBulletContainerStyles = selectBulletContainerStyles(themeTokens);
  const itemBulletPositioningStyles = selectBulletPositioningStyles(themeTokens);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    style: [sideItemContainerStyles, itemBulletContainerStyles],
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: [staticStyles.bulletPositioning, itemBulletPositioningStyles],
      testID: "unordered-item-bullet",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: bulletIcon,
        tokens: {
          color: bulletColor,
          size: themeTokens.itemIconSize
        }
      })
    })
  });
});
ListItemMark.displayName = 'ListItemMark';
ListItemMark.propTypes = {
  tokens: _propTypes.default.shape(tokenTypes).isRequired,
  /**
   * Renders side item icon
   */
  icon: _propTypes.default.elementType,
  /**
   * Will set display icon color
   */
  iconColor: _propTypes.default.string,
  /**
   * Allow the user define the icon size
   */
  iconSize: _propTypes.default.number
};
const staticStyles = _StyleSheet.default.create({
  bulletPositioning: {
    alignItems: 'center',
    justifyContent: 'center'
  }
});
var _default = exports.default = ListItemMark;